import { render } from "./ServiceFormRiver.vue?vue&type=template&id=6d78737f&scoped=true"
import script from "./ServiceFormRiver.vue?vue&type=script&lang=js"
export * from "./ServiceFormRiver.vue?vue&type=script&lang=js"

import "./ServiceFormRiver.vue?vue&type=style&index=0&id=6d78737f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d78737f"]])

export default __exports__